import {
  PROJECT_ALL,
  PROJECT_GET,
  PROJECT_DEL,
  PROJECT_PUT,
  PROJECT_POST,
  PROJECT_LOADING,
  PROJECT_ERROR,
  PROJECT_RESET,
} from '../types';

import api from '../../../utils/functions/api';

export const projectCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/project`,
      payload,
    );
    dispatch({ type: PROJECT_POST, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: PROJECT_ERROR });
    throw new Error(error);
  }
};

export const projectAll = (params) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_LOADING });
    const {
      name = '',
      size = 300,
      page = 1,
      status_deliver = '',
      profile = '',
      time_tracking_enabled = '',
      time_tracking_available = '',
      lite = '',
      slim_expenses = '',
    } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/project?name=${name}&size=${size}&page=${page}&status_deliver=${status_deliver}&profile=${profile}&time_tracking_enabled=${time_tracking_enabled}&time_tracking_available=${time_tracking_available}&lite=${lite}${slim_expenses ? '&slim_expenses=1' : ''}`,
    );
    if (status === 200) {
      dispatch({ type: PROJECT_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PROJECT_ERROR });
    throw new Error(error);
  }
};

export const projectGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/project/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PROJECT_GET, payload: data });
      return data;
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PROJECT_ERROR });
    throw new Error(error);
  }
};

export const projectPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/project/${id}`,
      payload,
    );
    dispatch({ type: PROJECT_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PROJECT_ERROR });
    throw new Error(error);
  }
};

// เปิด/ปิด checkout_gps_required ให้ทุกโครงการที่เปิด time_tracking_enabled (Profile) ทีเดียว
// ใช้ปุ่ม toggle รวมในหน้า HrCheckinManagement.js — ไม่ dispatch เข้า project list reducer
// เพราะ response ไม่ใช่ shape ของ list (แค่ modifiedCount) ตัว component จัดการ local state เอง
export const projectBulkSetCheckoutGps = (enabled) => async () => {
  try {
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/project/checkout-gps/bulk`,
      { enabled },
    );
    return data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
};

export const projectDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/project/${id}`,
    );
    dispatch({ type: PROJECT_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PROJECT_ERROR });
    throw new Error(error);
  }
};

export const projectPatchDashboard = (id, payload) => async () => {
  await api.patch(
    `${process.env.REACT_APP_API_URL}/project/${id}/dashboard`,
    payload,
  );
};

// ติ๊ก/ยกเลิกติ๊ก "ตรวจสอบแล้ว" ของวันนี้ — คืน { review_checks, checkedToday }
export const projectToggleReviewCheck = (id) => async () => {
  const { data } = await api.patch(
    `${process.env.REACT_APP_API_URL}/project/${id}/review-check`,
  );
  return data;
};

// ให้ AI สรุปเรื่องราวจากหมายเหตุของโครงการ — คืน { summary, provider, model, generated_at, source, cached?, stale?, error? }
// force=true = สรุปใหม่เสมอ (ปุ่ม "สรุปใหม่") ไม่ใช่ = ใช้ผลที่เก็บไว้ถ้าบันทึกยังไม่เปลี่ยน
export const projectSummarizeNotes = (id, force = false, provider = '') => async () => {
  const { data } = await api.post(
    `${process.env.REACT_APP_API_URL}/project/${id}/notes-summary`,
    { force, provider: provider || undefined },
  );
  return data;
};

// Optimistic local update — ไม่ call API, แค่อัป Redux store ทันที
export const projectUpdateLocal = (id, fields) => (dispatch) => {
  dispatch({ type: PROJECT_PUT, payload: { _id: id, id, ...fields } });
};

export const projectReset = () => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_RESET });
  } catch (error) {
    console.error(error);
    dispatch({ type: PROJECT_ERROR });
    throw new Error(error);
  }
};
